import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import DetailsContainer from './containers/DetailsContainer'
import Container from './containers/Container'
import RatingList from './components/List'

const ratingRoutes = (
  <Route
    component={Container}
    key="rating-routes"
    path={getPath('backend', '/rating')}
  >
    <IndexRoute component={RatingList} />
    <Route
      path={getPath('backend', '/rating/:id')}
      component={DetailsContainer}
    />
  </Route>
)

export default ratingRoutes



// WEBPACK FOOTER //
// ./src/rating/routes.js